
import {ExternalLink} from 'react-feather'
import {Tooltip} from "react-tooltip";


const MobilePreview = (props) => {
    const {url, title, scroll} = props
    const styles = {width: '100%', height: '100%'}
    const Iframe = <iframe title={title} height="100%" style={styles} src={url} />


    return (
        <div className="mobile-preview">
            <div className='phone-container'>
                <div className="device phone">
                    <div className={`screen ${!scroll ? 'no-scroll' : ''}`}>
                        {url && <>{Iframe}</>}
                    </div>
                    <div className="button">
                        <a href={props.url}
                            target="__blank"
                            className="button-icon"
                            data-tip={`Open in new window`}
                            data-place={'bottom'}>
                            <ExternalLink/>
                        </a>
                        <Tooltip/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MobilePreview;